// extracted by mini-css-extract-plugin
export default {"zoomModal":"t1-z"};